import { AxiosError } from 'axios';
import useSWR from 'swr';

import { MessageT, WithStatusT } from '@consumer-frontend/nc-utils';

import { apiEndpoints, ONE_MINUTE_IN_MS } from '../lib';

export type UseMessagesPropsT = {
  accountId: string;
  limit?: number;
  offset?: number;
};
export type MessagesReturnT = {
  count: number;
  messages: MessageT[];
};

// eslint-disable-next-line @stylistic/object-curly-newline
export const useMessages = ({ accountId, limit, offset }: UseMessagesPropsT) => {
  const queryParams: Record<string, string> = {};

  if (limit) { queryParams.limit = limit.toString(); }
  if (offset) { queryParams.offset = offset.toString(); }

  // eslint-disable-next-line @stylistic/object-curly-newline
  const { data, error, isLoading } = useSWR<WithStatusT<MessagesReturnT>, AxiosError>(
    () => (accountId ? apiEndpoints.dashboard.messages(accountId, queryParams) : null),
    // Since the result of this endpoint is unlikely to change very frequently, don't re-make
    // the same request more than once a minute.
    { dedupingInterval: ONE_MINUTE_IN_MS },
  );

  return {
    count: data?.count,
    error,
    isLoading,
    messages: data?.messages,
    status: data?.status || error?.status,
  };
};
